import React, { useEffect, useState } from 'react';
import HeroDesktop from './HeroDesktop';
import HeroMobile from './HeroMobile';

const Hero = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint
    };

    // Initial check
    checkMobile();

    // Add event listener
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile ? <HeroMobile /> : <HeroDesktop />;
};

export default Hero; 